var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottery"},_vm._l((_vm.lottery),function(p,i){return _c('div',{key:i,staticClass:"sec lotteryBoxDisaply",style:(_vm.lotteryBoxPosition(p)),domProps:{"textContent":_vm._s(p.nickname)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }